<template>
  <div>
    <div class="monitor container is-fluid">
      <div class="columns">
        <div class="column is-8">
          <h4 class="is-size-4-desktop">
            Recuento N&deg; {{ numeroDocumento }}
          </h4>
          <h4 class="is-size-6-desktop">
            Sucursal: {{ bodega.sucursal.nombre }} / {{ bodega.nombre }}
          </h4>
        </div>
      </div>
      <div v-if="recuento" class="columns">
        <div class="column is-12">
          <table class="table is-narrow is-bordered is-fullwidth">
            <tbody>
              <tr>
                <td>Document Entry</td>
                <td>
                  <strong>{{ recuento.documentEntry }}</strong>
                </td>
                <td>Document Number</td>
                <td>
                  <strong>{{ recuento.documentNumber }}</strong>
                </td>
                <td>Fecha Creaci&oacute;n</td>
                <td>
                  <strong>{{
                    format(parseISO(recuento.fechaCreacion), 'dd/MM/yyyy HH:mm')
                  }}</strong>
                </td>
                <td>Fecha</td>
                <td>
                  <strong>{{
                    format(parseISO(recuento.fecha), 'dd/MM/yyyy HH:mm')
                  }}</strong>
                </td>
                <td>Estado</td>
                <td>
                  <strong>{{ recuento.estado }}</strong>
                </td>
              </tr>
              <tr>
                <td>Motivo</td>
                <td colspan="3">
                  <strong>{{ recuento.motivo }}</strong>
                </td>
                <td>Comentario</td>
                <td colspan="3">
                  <strong>{{ recuento.comentario }}</strong>
                </td>
                <td>Descargado por</td>
                <td colspan="3">
                  <strong>{{ recuento.usuario.nombre }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-loading
            v-model="isLoading"
            :is-full-page="false"
            :can-cancel="false"
          ></b-loading>
          <b-tabs
            v-model="pestanaActual"
            type="is-toggle"
            @input="tabChangeHandle"
          >
            <b-tab-item label="Folios">
              <recuento-folios
                v-if="recuento && pestanaActual === 0"
                :key="forceKeys[0]"
                :recuento="recuento"
              ></recuento-folios>
            </b-tab-item>
            <b-tab-item label="Comparador">
              <comparador
                v-if="recuento && pestanaActual === 1"
                :key="forceKeys[1]"
                :recuento="recuento.id"
              />
            </b-tab-item>
            <b-tab-item label="Resumen">
              <resumen
                v-if="recuento && pestanaActual === 2"
                :key="forceKeys[2]"
                :recuento="recuento.id"
              />
            </b-tab-item>
          </b-tabs>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <router-link
            tag="button"
            class="button"
            title="Ver detalle"
            :to="`/inventario/recuentos`"
          >
            Volver
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { mapGetters } from 'vuex'

import Comparador from '@/components/comparador-v2/Comparador'
import RecuentoFolios from '@/components/inventario/RecuentoFolios'
import Resumen from '@/components/resumen-recuento/Resumen'
import { inventarioService } from '@/services'

export default {
  name: 'Recuento',
  components: {
    Comparador,
    RecuentoFolios,
    Resumen
  },
  data() {
    return {
      recuentoId: null,
      recuento: null,
      isLoading: false,
      pestanaActual: 0,
      forceKeys: [],
      format,
      parseISO
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    numeroDocumento() {
      return this.recuento ? this.recuento.documentNumber : '00000000'
    }
  },
  created() {
    this.recuentoId = this.$route.params.id
    this.getRecuento(this.recuentoId)
  },
  methods: {
    tabChangeHandle(tab) {
      if (typeof this.forceKeys[tab] === 'undefined') this.forceKeys[tab] = 0
      else this.forceKeys[tab]++
    },
    async getRecuento(recuentoId) {
      const self = this
      self.isLoading = true
      await inventarioService
        .getRecuento(recuentoId)
        .then((response) => (self.recuento = response.data))
        .catch((error) => this.procesarError(error))
        .then(() => (self.isLoading = false))
    }
  }
}
</script>
